import React from 'react';

function Footer() {
  return <div className="footer" />;
}

export default Footer;
